var _desc, _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKuzelAdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1364 0 0 1.1364 500.0145 500.0145)",
    id: 798571
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 0 165.8727)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,153,17)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-244.916,8.4395 -244.916,-8.4395 0.001,-149.8415 244.916,-8.4395 244.916,8.4395 0.001,149.8415 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 0.0019 -65.8797)",
    id: "SVGCleanerId_0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(241,135,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-256.0012, -213.837)",
    d: "M 382.247 336.943 l -77.291 -310.99 h -0.009 c -0.941 -6.455 -5.655 -12.757 -14.162 -17.669 c -19.131 -11.045 -50.435 -11.045 -69.566 0 c -8.507 4.912 -13.222 11.214 -14.162 17.669 h -0.009 l -77.292 310.99 c -9.104 24.084 2.475 50.31 34.74 68.938 c 50.328 29.057 132.683 29.057 183.012 0 C 379.77 387.253 391.35 361.026 382.247 336.943 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 0.0019 -65.8797)",
    id: "SVGCleanerId_0_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(241,135,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-256.0012, -213.837)",
    d: "M 382.247 336.943 l -77.291 -310.99 h -0.009 c -0.941 -6.455 -5.655 -12.757 -14.162 -17.669 c -19.131 -11.045 -50.435 -11.045 -69.566 0 c -8.507 4.912 -13.222 11.214 -14.162 17.669 h -0.009 l -77.292 310.99 c -9.104 24.084 2.475 50.31 34.74 68.938 c 50.328 29.057 132.683 29.057 183.012 0 C 379.77 387.253 391.35 361.026 382.247 336.943 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 -191.3398 276.343)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(241,135,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "122.4585,62.2615 122.4585,79.1405 -122.4585,-62.2615 -122.4585,-79.1405 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 191.3414 276.343)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(208,116,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    points: "-122.4575,62.2615 -122.4575,79.1405 122.4575,-62.2615 122.4575,-79.1405 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 0.0015 -355.6782)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,153,17)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-256.001, -28.366)",
    d: "M 221.218 48.448 c -19.131 -11.045 -19.131 -29.119 0 -40.164 s 50.435 -11.045 69.566 0 c 19.131 11.045 19.131 29.119 0 40.164 C 271.653 59.493 240.348 59.493 221.218 48.448 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 0 -355.6782)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(208,116,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-256, -28.366)",
    d: "M 235.13 40.415 c -11.478 -6.627 -11.478 -17.471 0 -24.098 s 30.261 -6.627 41.74 0 c 11.478 6.627 11.478 17.471 0 24.098 S 246.609 47.042 235.13 40.415 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 -0.0024 -46.257)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(224,224,226)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-255.9985, -226.3955)",
    d: "M 362.967 259.374 l -26.3 -105.819 c -3.277 2.736 -7.004 5.342 -11.215 7.773 c -38.2 22.054 -100.708 22.054 -138.907 0 c -4.211 -2.431 -7.937 -5.037 -11.215 -7.774 l 0 0 l -26.3 105.819 c 5.071 5.56 11.202 10.804 18.412 15.594 c 48.705 32.36 128.406 32.36 177.111 0 C 351.765 270.178 357.898 264.933 362.967 259.374 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7483 0 0 0.7483 650.9182 643.3078)",
    id: 335392
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 0 0)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,205,84)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-256, -256)",
    d: "M 512 256.006 C 512 397.402 397.394 512.004 256.004 512 C 114.606 512.004 0 397.402 0 256.006 C -0.007 114.61 114.606 0 256.004 0 C 397.394 0 512 114.614 512 256.006 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 59.8852 59.8852)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(244,186,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-294.3265, -294.3265)",
    d: "M 511.936 258.555 c -0.116 -0.116 -0.234 -0.234 -0.35 -0.35 c -0.306 -0.308 -128.129 -128.131 -128.436 -128.436 C 350.65 97.035 305.661 76.717 256 76.717 c -98.855 0 -179.283 80.428 -179.283 179.283 c 0 49.659 20.316 94.646 53.049 127.146 c 0.306 0.308 0.612 0.614 0.921 0.921 c 0.306 0.308 127.209 127.211 127.517 127.516 c 0.117 0.118 0.236 0.236 0.353 0.353 C 397.913 510.572 510.57 397.916 511.936 258.555 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 0 0)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(244,246,249)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-256, -256)",
    d: "M 256 76.717 c -98.855 0 -179.283 80.428 -179.283 179.283 S 157.145 435.283 256 435.283 S 435.283 354.855 435.283 256 S 354.855 76.717 256 76.717 z M 256 420.342 c -90.619 0 -164.342 -73.724 -164.342 -164.342 S 165.381 91.658 256 91.658 S 420.342 165.381 420.342 256 S 346.619 420.342 256 420.342 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5625 0 0 1.5625 0.0001 0.0001)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(244,246,249)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-256, -256)",
    d: "M 345.642 248.53 H 263.47 v -82.172 c 0 -4.126 -3.341 -7.47 -7.47 -7.47 c -4.129 0 -7.47 3.345 -7.47 7.47 v 82.172 h -82.172 c -4.129 0 -7.47 3.345 -7.47 7.47 c 0 4.126 3.341 7.47 7.47 7.47 h 82.172 v 82.172 c 0 4.126 3.341 7.47 7.47 7.47 c 4.129 0 7.47 -3.345 7.47 -7.47 V 263.47 h 82.172 c 4.129 0 7.47 -3.345 7.47 -7.47 C 353.111 251.874 349.771 248.53 345.642 248.53 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuzelAdd);
export default __webpack_public_path__ + "static/media/kuzelAdd.dfb38711f7e670604b4a572f1a09148b.svg";
export { ForwardRef as ReactComponent };